import SectionHeader from './SectionHeader';
import withHorizontalScroll from './withHorizontalScroll';

const HorizontalScrollMediaView = ({
  collection,
  headTitle,
  route,
  containerRef,
  showLeftButton,
  showRightButton,
  scroll,
  checkScrollPosition,
  navigate,
}) => {
  return (
    <div className="relative w-full hover:cursor-pointer">
      <SectionHeader
        title={headTitle}
        handleNext={() => scroll('right')}
        handlePrev={() => scroll('left')}
        showLeftButton={showLeftButton}
        showRightButton={showRightButton}
        showViewAll={false}
      />
      <div
        ref={containerRef}
        onScroll={checkScrollPosition}
        className="flex gap-2 sm:gap-4 overflow-x-auto w-full scrollbar-hide touch-pan-x"
        style={{ scrollBehavior: 'smooth', touchAction: 'pan-x pan-y' }}
      >
        {collection.map((item) => (
          <div
            onClick={() => navigate(`/${route}/${item.id}`)}
            key={item.id}
            className="bg-charcoal p-2 sm:p-3 md:p-4 hover:bg-hover-charcoal rounded-lg flex-none w-[40vw] sm:w-[35vw] md:w-[30vw] lg:w-[25vw] xl:w-[20vw] max-w-[300px]"
          >
            <div className="relative pb-[100%]">
              <img
                src={item.cover_art}
                alt={item.title}
                className="absolute top-0 left-0 w-full h-full rounded-lg object-cover"
              />
            </div>
            <div className="pt-[0.5rem]">
              <h1 className="text-base sm:text-lg md:text-xl lg:text-2xl xl:text-3xl font-bold">
                {item.title}
              </h1>
              <p className="text-xs font-medium">{item.artist}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default withHorizontalScroll(HorizontalScrollMediaView);